import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import useIsMobile from 'Hooks/Common/useIsMobile';

import { settingsNavItems } from './SettingsNavItems';

function SettingsNavigation() {
  const isMobile = useIsMobile();
  const location = useLocation();

  return (
    <div className="settingsNav__list">
      {settingsNavItems.map((item, index) => {
        const { pathname } = location;
        const { path, label, icon, classNameMod } = item;
        const isActive = pathname.startsWith(path);
        return (
          <Link
            key={index}
            to={path}
            className={classNames(
              `settingsNav__item settingsNav__item--${classNameMod}`,
              {
                'settingsNav__item--active': isActive,
                mobile: isMobile,
              },
            )}
          >
            {!isMobile && <ReactSVG src={icon} className="settingsNav__item-icon" />}
            {label}
          </Link>
        );
      })}
    </div>
  );
}

export default SettingsNavigation;
